import type { Page } from '@inertiajs/core';
import { usePage } from '@inertiajs/vue3';

function determinePiniaPersistedStateKey(storeId: string, props: Page | undefined = undefined): string {
    if (props === undefined) {
        props = usePage().props;
    }

    return `${props.langCode}-${props.wizardType}-${storeId}`;
}

export {
    determinePiniaPersistedStateKey,
};
